// extracted by mini-css-extract-plugin
export default {"top-creators-block":"styles_top-creators-block__o+QOA","top-creators-block--gray-bg":"styles_top-creators-block--gray-bg__7a5uT"};